module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"engineRebuildingCanceledOrders":"Órdenes Canceladas de la Rectificadora"},"en":{"engineRebuildingCanceledOrders":"Engine Rebuilding Canceled Orders"}}')
  delete Component.options._Ctor
}
